module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"cancel":"Abbrechen","signingOut":"Abmeldung erfolgt…"},"en":{"cancel":"Cancel","signingOut":"Signing out…"}}')
  delete Component.options._Ctor
}
